const state = {
  filter: {
    tasktype: '',
    tag: '',
    score: '',
    filetype: ''
  }
}

const mutations = {
  SET_OPTIONS (state, payload) {
    state.filter = { ...state.filter, ...payload }
  }
}

const actions = {

}

const getters = {
  score (state) {
    return state.filter.score
  },
  tag (state) {
    return state.filter.tag
  },
  tasktype (state) {
    return state.filter.tasktype
  },
  filetype (state) {
    return state.filter.filetype
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
